import React, { useContext, useState } from 'react';
import SecondaryNav from './SecondaryNav/SecondaryNav';
import { ApButtonTab } from '@alixpartners/ui-components';
import { ContentDiv, FlexWrapper } from './SupplierDiversity.styles';
import APStats from './AlixPartnersStats/APStats';
import AnalyzeClientData from './AnalyzeClientData/AnalyzeClientData';
import ExploreLibrary from './ExploreLibrary/ExploreLibrary';
import { VendorsByCategoryProvider } from 'contexts/SupplierDiversity/VendorsByCategoryProvider';
import { MultipleDiversityProvider } from 'contexts/SupplierDiversity/MultipleDiversityProvider';
import { AcrossUsaProvider } from 'contexts/SupplierDiversity/AcrossUsaProvider';
import { AnalyzeEditDataProvider } from 'contexts/SupplierDiversity/AnalyzeEditDataProvider';
import { ToastMessageProvider } from 'contexts/ToastMessageContext/ToastMessageProvider';
import { DiversedSpendProvider } from 'contexts/SupplierDiversity/DiversedSpendProvider';
import { DiversedSuppliersProvider } from 'contexts/SupplierDiversity/DiversedSuppliersProvider';
import { SettingsOptionsContext } from 'contexts/SettingsOptionsContext';
import { QueryStringContext } from 'contexts/QueryStringContext';
import { getCurrencySymbolFromOptions } from 'CategoryManagement/utils';
import { SettingsContext } from 'contexts/SettingsContext';

const INITIAL_SUBNAV_CONFIG = [
	{
		id: 1,
		name: 'analyze-client-data',
		label: 'Analyze Client Data',
		isActive: true,
		component: AnalyzeClientData,
	},
	{
		id: 2,
		name: 'alixparnters-stats',
		label: 'AlixPartners Stats',
		isActive: false,
		component: APStats,
	},
	{
		id: 3,
		name: 'explore-library',
		label: 'Explore Library',
		isActive: false,
		component: ExploreLibrary,
	},
];

const SupplierDiversity = () => {
	const [subNav, setSubNav] = useState(INITIAL_SUBNAV_CONFIG);
	const {
		options: { currency: currencyList },
	} = useContext(SettingsOptionsContext);
	const { currency } = useContext(QueryStringContext);
	const currencySymbol = getCurrencySymbolFromOptions(currencyList, currency);
	const { hideDecimals } = useContext(SettingsContext);
	const subNavHandler = value => {
		setSubNav(prevState =>
			prevState.map(el => {
				if (el.id === value) {
					return { ...el, isActive: true };
				} else {
					return { ...el, isActive: false };
				}
			})
		);
	};
	return (
		<>
			<SecondaryNav />
			<FlexWrapper>
				<div>
					{subNav.map(({ id, name, label, isActive }) => (
						<ApButtonTab
							key={`${id}_${name}`}
							name={name}
							isSelected={isActive}
							onClick={() => subNavHandler(id)}
						>
							{label}
						</ApButtonTab>
					))}
				</div>
				<div>
					{/* <ApButtonIcon
						title="Settings"
						iconName="settings"
						iconProps={{ iconColor: colors.grey8 }}
					/> */}
				</div>
			</FlexWrapper>
			<ToastMessageProvider>
				<VendorsByCategoryProvider>
					<AcrossUsaProvider>
						<MultipleDiversityProvider>
							<AnalyzeEditDataProvider
								currencySymbol={currencySymbol}
								hideDecimals={hideDecimals}
							>
								<DiversedSpendProvider
									currencySymbol={currencySymbol}
									hideDecimals={hideDecimals}
								>
									<DiversedSuppliersProvider>
										<ContentDiv>
											{subNav.map(({ id, isActive, component: Component }) => {
												return (
													isActive && (
														<Component
															key={id}
															currencySymbol={currencySymbol}
															hideDecimals={hideDecimals}
														/>
													)
												);
											})}
										</ContentDiv>
									</DiversedSuppliersProvider>
								</DiversedSpendProvider>
							</AnalyzeEditDataProvider>
						</MultipleDiversityProvider>
					</AcrossUsaProvider>
				</VendorsByCategoryProvider>
			</ToastMessageProvider>
		</>
	);
};

export default SupplierDiversity;
